/* eslint-disable jsx-a11y/anchor-is-valid */
import { useAuth } from '@context/Auth';
import { ENV } from 'config/ENV.config';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Languages } from './Languages';
import { ThemeMode } from './ThemeMode';

const HeaderUserMenu: FC = () => {
  const { userInfo, logout } = useAuth();
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src='/media/avatars/blank.png' />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {userInfo?.fullName}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {userInfo?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <ThemeMode />

      <div className='menu-item px-5'>
        <a href={`${ENV.portalOrigin}/profile`} target='_blank' className='menu-link px-5'>
          <i className='fa fa-user'></i>&nbsp; {<FormattedMessage id='USER_MENU.MY_PROFILE' />}
        </a>
      </div>

      <Languages />

      <div className='menu-item px-5'>
        <a
          href={`${ENV.portalOrigin}/change-password`}
          target='_blank'
          className='menu-link px-5'
        >
          <i className='fa fa-key'></i>&nbsp; {<FormattedMessage id='USER_MENU.CHANGE_PASSWORD' />}
        </a>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          <i className='fa fa-sign-out'></i>&nbsp; {<FormattedMessage id='USER_MENU.SIGN_OUT' />}
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
